<template>
  <sl-page>
    <div class='page-filter'>
      <Row :gutter="12">
        <Col span="5" :lg="5" :md="8" :sm="12" :xs="24" class="margin-bottom">
          <Input v-model="params.name" placeholder="企业名称"></Input>
        </Col>
        <Col span="5" :lg="5" :md="8" :sm="12" :xs="24" class="margin-bottom">
          <Input v-model="params.unionCreditCode" placeholder="统一信用代码"></Input>
        </Col>
        <Col span="5" :lg="5" :md="8" :sm="12" :xs="24" class="margin-bottom">
          <Input v-model="params.legalName" placeholder="法人姓名"></Input>
        </Col>
        <Col span="9" :lg="9" :md="24" :sm="12" :xs="24" class="page-action">
          <div>
            <Button type="primary" icon="ios-search" @click="list()">搜索</Button>
            <Button icon="ios-reset" @click="reset()">清空</Button>
          </div>
          <div>
            <Button type="primary" icon="md-add" @click="create()">新增</Button>
          </div>
        </Col>
      </Row>
    </div>
    <div class="pg-bd">
      <sl-table ref="table" :loading="loading" :page="page" :columns="columns" :data="data" @on-update="handleChange"></sl-table>
    </div>
    <enterprise-item ref="item" @on-update="handleUpdate"></enterprise-item>
  </sl-page>
</template>
<script>

import enterpriseItem from './detail'

const columns_ = [
  {
    title: '公司名称',
    key: 'name'
  },
  {
    title: '统一信用代码',
    key: 'unionCreditCode'
  },
  {
    title: '法人姓名',
    key: 'legalName'
  },
  {
    title: '法人电话',
    key: 'legalPhone'
  },
  {
    title: '实控人姓名',
    key: 'controlName'
  },
  {
    title: '实控人电话',
    key: 'controlPhone'
  },
]

export default {
  components: { enterpriseItem },
  data() {
    return {
      columns: [
        ...columns_,
        {
          title: '操作',
          key: 'action',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              // h('a', {
              //   props: {
              //     type: 'primary',
              //     size: 'small'
              //   },
              //   style: {
              //     marginRight: '5px'
              //   },
              //   on: {
              //     click: () => {
              //       this.view(params)
              //     }
              //   }
              // }, '详情'),
              h('a', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.edit(params)
                  }
                }
              }, '编辑')
            ])
          }
        }
      ],
      data: [],
      params: {
        name: null,
        unionCreditCode: null,
        legalName: null,
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      selection: []
    }
  },
  computed: {
    removeDisable() {
      return this.selection.length == 0
    }
  },
  created() {
    this.def = { ...this.params }
    this.list()
  },

  methods: {

    list() {
      let params = { search: { ...this.params }, pageSize: this.page.pageSize, pageNum: this.page.pageNum }
      this.loading = true
      this.$request.ciEnterprises(params).then(resp => {
        this.loading = false
        if (!resp.code) {
          this.data = this.$utils.conv(resp.data.list || [])
          this.page.total = resp.data.total || 0
        }
      })
    },

    edit({ row }) {
      this.$refs['item'].init(row.id)
    },

    create() {
      this.$refs['item'].init()
    },

    remove({ row }) {
      this.$ui.confirm(this.$request.companyDelete, `确定删除 ${row.name} ？`)(row.id).then(resp => {
        if (!resp.code) {
          this.$Message.success('操作成功')
          this.selection = []
          this.list()
        }
      })
    },

    view({row}){

    },

    reset() {
      this.$utils.fill(this.params, this.def)
      console.log( this.params )
      this.list()
    },


    handleUpdate() {
      this.modalVisible = false
      this.list()
    },

    handleChange(pageNum, pageSize) {
      if (this.page.pageNum != pageNum || this.page.pageSize != pageSize) {
        this.page.pageNum = pageNum
        this.page.pageSize = pageSize
        this.list()
      }
    }

  }
}

</script>